import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StatisticService } from '../../../../_services';
import { TrainingDataAnalysisModalComponent } from '../_component/data-analysis-modal.component';
import { TrainingDataAnalysisValueComponent } from '../_component/data-analysis-value.component';

@Component({
    selector: 'training-data-analysis',
    templateUrl: 'training.component.html',
    styles: [
        `
            table thead th {
                font-size: 10px;
            }

            table a {
                display: inline-block;
                width: 100%;
                color: #666;
                height: 100%;
                padding: 8px;
                text-decoration: none;
            }

            table tbody td {
                padding: 0;
            }

            .all-height {
                position: relative;
            }

            .all-height a {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
            }

            .diversification {
                margin-top: 20px;
                margin-bottom: 60px;
                font-weight: bold;
                font-size: 1.1em;
                text-align: center;
            }

            .diversification h3 {
                margin: 0;
            }

            .table-top.table-striped > tbody > tr:nth-of-type(odd) {
                background-color: rgba(190, 229, 235, 0.3);
            }

            .table-top.table-striped > tbody > tr:nth-of-type(even) {
                background-color: rgba(190, 229, 235, 0.1);
            }

            .table-top.table-striped > tbody > tr:nth-of-type(odd):hover {
                background-color: rgba(190, 229, 235, 0.6);
            }

            .table-top.table-striped > tbody > tr:nth-of-type(even):hover {
                background-color: rgba(190, 229, 235, 0.6);
            }

            .delta {
                font-size: 10px;
                opacity: 0.7;
                white-space: nowrap;
            }

            .value {
                white-space: nowrap;
            }

            .value.big,
            .delta.big {
                zoom: 1.3;
            }
        `,
    ],
})
export class TrainingDataAnalysisComponent implements OnInit {
    private _fromDate: string;
    private _toDate: string;

    rawData: any;
    rawDataTop15: any;
    rawDataOthers: any;
    loaded: boolean = false;

    currentChart: any = {
        labels: [],
        data: [],
        type: 'pie',
        legend: false,
    };

    previousChart: any = {
        labels: [],
        data: [],
        type: 'pie',
        legend: false,
    };

    diversification: any = { others: {}, top: {} };

    options: any = {
        cutoutPercentage: 50,
        tooltips: {
            callbacks: {
                label: function (item, data) {
                    const total = data.datasets[0].data.reduce(
                        (total, d) => total + d,
                        0
                    );

                    let value = data.datasets[0].data[item.index];
                    const percent = ((value * 100) / total).toFixed(1);

                    return data.labels[item.index] + ' (' + percent + '%)';
                },
            },
        },
    };

    @ViewChild('infoModal')
    infoModal: TrainingDataAnalysisModalComponent;

    @Input()
    set fromDate(date: string) {
        this._fromDate = date;
        this.updateDates(this._fromDate, this._toDate);
    }

    get fromDate() {
        return this._fromDate;
    }

    @Input()
    set toDate(date: string) {
        this._toDate = date;
        this.updateDates(this._fromDate, this._toDate);
    }

    get toDate() {
        return this._toDate;
    }

    constructor(private statService: StatisticService) {}

    chartClicked(e: any): void {
        console.log(e);
    }

    chartHovered(e: any): void {
        console.log(e);
    }

    updateData(rawData): void {
        this.rawData = rawData.slice();

        let top;

        if (rawData.length > 15) {
            top = rawData.splice(0, 15);
            this.rawDataTop15 = this.rawData.slice().splice(0, 15);
            this.rawDataOthers = this.rawData.slice().splice(16);
            const others = this.aggregateOthers(rawData);

            this.diversification.top.data = this.aggregateOthers(top);
            this.diversification.others.data = others;
            this.computeConclusion();

            top.push(others);
        } else {
            top = rawData;
        }

        this.currentChart.labels.length = 0;
        this.currentChart.data.length = 0;
        this.previousChart.labels.length = 0;
        this.previousChart.data.length = 0;

        let totalCurrent = 0;
        let totalPrevious = 0;

        top.forEach((data) => {
            this.currentChart.labels.push(data.training.title);
            this.currentChart.data.push(data.value.current.turnover / 100);
            this.previousChart.labels.push(data.training.title);
            this.previousChart.data.push(data.value.previous.turnover / 100);
            totalCurrent += data.value.current.turnover;
            totalPrevious += data.value.previous.turnover;
        });

        this.loaded = false;
        setTimeout((_) => (this.loaded = true), 5);
    }

    updateDates(from: string, to: string): void {
        if (!from || !to) {
            return;
        }
        this.statService
            .getTrainingStatisticsBetween(from, to, false)
            .subscribe((rawData) => this.updateData(rawData));
    }

    computeConclusion() {
        this.diversification.top.total =
            this.diversification.top.data.value.current.turnover;
        this.diversification.others.total =
            this.diversification.others.data.value.current.turnover;
        this.diversification.top.delta =
            this.diversification.top.data.value.current.turnover -
            this.diversification.top.data.value.previous.turnover;
        this.diversification.others.delta =
            this.diversification.others.data.value.current.turnover -
            this.diversification.others.data.value.previous.turnover;
        this.diversification.top.totalPercent =
            (100 * this.diversification.top.data.value.current.turnover) /
            (this.diversification.top.data.value.current.turnover +
                this.diversification.others.data.value.current.turnover);
        this.diversification.others.totalPercent =
            (100 * this.diversification.others.data.value.current.turnover) /
            (this.diversification.top.data.value.current.turnover +
                this.diversification.others.data.value.current.turnover);
        this.diversification.top.deltaPercent =
            this.diversification.top.totalPercent -
            (100 * this.diversification.top.data.value.previous.turnover) /
                (this.diversification.top.data.value.previous.turnover +
                    this.diversification.others.data.value.previous.turnover);
        this.diversification.others.deltaPercent =
            this.diversification.others.totalPercent -
            (100 * this.diversification.others.data.value.previous.turnover) /
                (this.diversification.top.data.value.previous.turnover +
                    this.diversification.others.data.value.previous.turnover);

        this.diversification.top.totalS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.top.total,
                true,
                false
            );
        this.diversification.others.totalS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.others.total,
                true,
                false
            );
        this.diversification.top.deltaS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.top.delta,
                true,
                true
            );
        this.diversification.others.deltaS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.others.delta,
                true,
                true
            );
        this.diversification.top.totalPercentS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.top.totalPercent,
                false,
                false,
                true
            );
        this.diversification.others.totalPercentS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.others.totalPercent,
                false,
                false,
                true
            );
        this.diversification.top.deltaPercentS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.top.deltaPercent,
                false,
                true,
                true
            );
        this.diversification.others.deltaPercentS =
            TrainingDataAnalysisValueComponent.formatValue(
                this.diversification.others.deltaPercent,
                false,
                true,
                true
            );
    }

    ngOnInit(): void {}

    private aggregateOthers(others): any {
        return others.reduce(
            (other, training) => {
                other.value.current.sessionCount +=
                    training.value.current.sessionCount;
                other.value.current.sessionCount +=
                    training.value.current.sessionCount;
                other.value.current.turnover += training.value.current.turnover;
                other.value.current.sessions.push(
                    ...training.value.current.sessions
                );

                other.value.previous.sessionCount +=
                    training.value.previous.sessionCount;
                other.value.previous.sessionCount +=
                    training.value.previous.sessionCount;
                other.value.previous.turnover +=
                    training.value.previous.turnover;
                other.value.previous.sessions.push(
                    ...training.value.previous.sessions
                );

                return other;
            },
            {
                training: {
                    id: 0,
                    title: 'AUTRE',
                },
                value: {
                    current: {
                        sessionCount: 0,
                        studentCount: 0,
                        turnover: 0,
                        sessions: [],
                    },
                    previous: {
                        sessionCount: 0,
                        studentCount: 0,
                        turnover: 0,
                        sessions: [],
                    },
                },
            }
        );
    }

    openInfoModal(data) {
        this.infoModal.display(
            'Détail de la formation ' + data.training.title,
            data
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/training/training.component.ts